import React, { useState, useEffect } from 'react';
import { Authme, showToast } from '../../Pages/Utils/utils';
import { FaCog } from "react-icons/fa";
import { Link } from 'react-router-dom';
import "./Userprofile.css";
import { FiLogOut } from "react-icons/fi";
import { persistor } from '../../Pages/Redux/Store';
import Loader from '../Loader/Loader';
import { connect, useDispatch } from 'react-redux';
import { UserData } from '../../Pages/Redux/action/UserSession';


const Userprofile = (props) => {
  const [userDetails, setUserDetails] = useState(props?.userdata);
  const [Loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleAuthme = async () => {
    let token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found!");
      return;
    }

    try {
      const response = await Authme(token);
      setUserDetails(response.data);
    } catch (error) {
      console.error("Error during Authme request:", error);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      if (token) {
        localStorage.removeItem("token");
        localStorage.removeItem("sessionid")
        persistor.purge();
        showToast("Logout successfully", "success");
        setTimeout(() => {
          window.location.href = "/";
        }, [1000])

      } else {
        console.warn("No token found to remove.");
        showToast("No active token found", "error");
      }
    } catch (error) {
      console.error("Error during logout:", error);
      showToast("Something went wrong", "error");
    } finally {
      setLoading(false)
    }
  };


  // useEffect(() => {
  //   handleAuthme();
  // }, []);




  const getAuthData = async () => {

    var res = await dispatch(UserData())
    // props?.getUserData(res.data)
  }
  useEffect(() => {
    getAuthData()
  }, [])

  console.log(userDetails?.role)
  return (
    <>
      {Loading && <Loader />}
      <Link to={userDetails?.role == 'hospital_provider' ? '/survey-dashboard' : "/dashboard"} style={{ textDecoration: "none", color: "" }}>
        <div className='d-flex align-items-center gap-2'>
          <img className="img-fluid userimg" src={userDetails?.image ? userDetails?.image : "/Images/user.svg"} alt="user-icon" />
          <span className='user-name'>Hi, {userDetails ? userDetails.name ? userDetails.name : userDetails.full_name : "user not found"}</span>
        </div>
      </Link>

      <div className='d-flex gap-2 align-items-center'>
        <div>
          <Link to="/updatepassword" style={{ textDecoration: "none" }}>
            <div className='notification'>
              <img className='img-fluid resetpass' src="/Images/reset-password.svg" />
            </div>
          </Link>
        </div>
        <div className="">
          <button className="logoutbtn d-flex  align-items-center gap-1 p-2" onClick={handleLogout}>
            <FiLogOut size={"20px"} color='#17A0C7' />
          </button>
        </div>
        <div className='notification'>
          <img className='img-fluid bell-icon' src="/Images/bell-icon.svg" alt="not-fication-icon" />
        </div>
      </div>
    </>
  );
}


const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Userprofile);